import React from 'react'
import HumanReviewProgressCard from './human-review-progress/HumanReviewProgressCard'
import DistributionBetweenPhasesCard from './distribution-between-phases/DistributionBetweenPhasesCard'
import ConfidenceDistributionCard from './confidence-distribution/ConfidenceDistributionCard'
import Masonry from 'react-masonry-css'
import './text-analytics-masonry.scss'

const TextAnalyticsReportSection = () => {
    const chartComponents = [
        <HumanReviewProgressCard key='human-review' />,
        <DistributionBetweenPhasesCard key='distribution-phases' />,
        <ConfidenceDistributionCard key='confidence-distribution' />,
    ]
    
    // Define breakpoints for responsive behavior
    const breakpointColumnsObj = {
        default: 2, // Default to 2 columns
        1100: 2,    // 2 columns at 1100px wide
        1000: 1      // 1 column at 1000px wide and below
    }
    
    return (
        <Masonry
            breakpointCols={breakpointColumnsObj}
            className="masonry-grid"
            columnClassName="masonry-grid_column"
        >
            {chartComponents.map((Component, index) => (
                <div key={index} className="masonry-item">
                    {Component}
                </div>
            ))}
        </Masonry>
    )
}

export default TextAnalyticsReportSection
